var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoTableCabanaASelected = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M11 20.404C11 19.076 12.063 18 13.375 18h33.25C47.937 18 49 19.076 49 20.404v20.192C49 41.924 47.937 43 46.625 43h-33.25C12.063 43 11 41.924 11 40.596V20.404Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M50.75 34.662A1 1 0 0 1 50 35H10a1 1 0 0 1-.992-1.124l2-16A1 1 0 0 1 12 17h36a1 1 0 0 1 .992.876l2 16a1 1 0 0 1-.242.786ZM47.117 19H12.883l-1.75 14h37.734l-1.75-14Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M30 17a1 1 0 0 1 1 1v16a1 1 0 1 1-2 0V18a1 1 0 0 1 1-1ZM38.938 17.002a1 1 0 0 1 1.06.936l.998 16a1 1 0 1 1-1.996.124l-.998-16a1 1 0 0 1 .936-1.06ZM21.06 17.002a1 1 0 0 0-1.06.936l-.998 16a1 1 0 1 0 1.996.124l.998-16a1 1 0 0 0-.936-1.06Z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M10 18a1 1 0 0 1 1-1h38a1 1 0 1 1 0 2H11a1 1 0 0 1-1-1Z",
  clipRule: "evenodd"
})));
SvgNoTableCabanaASelected.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoTableCabanaASelected);
export default ForwardRef;